import { debounce } from '../parts/helpers';
const windowScrollHandlers = () => {
    const siteHeader = window.document.querySelector('.js-site-header');
    window.document.addEventListener('scroll', debounce(() => {
        const lastKnownScrollPosition = window.scrollY;
        const operationType = lastKnownScrollPosition > 100 && window.innerWidth > 1024 ? 'add' : 'remove';
        siteHeader && siteHeader.classList[operationType]('scrolled');
    }, 50));
};
export default windowScrollHandlers;
